// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".remarkText{color:red;font-size:14px;margin-bottom:3px;text-align:center}.marginBottom{margin-top:20px}.text-right{text-align:right}.remarkPopup .dg-content-cont--floating{margin-top:0;position:absolute;top:8%;transform:translateY(0)}.closeBtn{cursor:pointer;font-size:22px;position:absolute;right:0;top:-10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
